import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { BannerContext } from '../../App';
import OpenIdVcRequestQR from '../Auth/OpenIdVcRequestQR';
import FaceCapturePage from '../Face/FaceCapturePage';
import './UiPreview.css';

const PREVIEW_ITEMS = [
  {
    id: 'qr-pending',
    title: 'QR 인증 중',
    description: 'QR을 흐리게 표시하고 Wallet 인증 진행을 보여주는 화면',
  },
  {
    id: 'qr-error',
    title: 'QR 인증 실패',
    description: '티켓 또는 DID 인증이 실패했을 때의 화면',
  },
  {
    id: 'qr-success',
    title: 'QR 인증 성공',
    description: '얼굴 촬영 화면으로 넘어가기 직전의 화면',
  },
  {
    id: 'face-camera',
    title: '얼굴 자동 인식',
    description: '얼굴을 감지하면 버튼 없이 자동 촬영하는 화면',
  },
  {
    id: 'face-processing',
    title: '얼굴 인증 중',
    description: '실제 카메라 위에 얼굴 인증 로딩을 보여주는 화면',
  },
  {
    id: 'face-retry',
    title: '얼굴 인증 실패',
    description: '공통 오류 모달에서 재촬영 또는 QR 복귀를 선택하는 화면',
  },
  {
    id: 'face-success',
    title: '얼굴 인증 성공',
    description: '최종 입장 가능 여부를 보여주는 화면',
  },
  {
    id: 'camera-error',
    title: '카메라 오류',
    description: '권한 거부 또는 카메라 사용 불가 화면',
  },
];

const FACE_PREVIEW_STATES = {
  'face-camera': 'camera',
  'face-processing': 'processing',
  'face-retry': 'retry',
  'face-success': 'success',
  'camera-error': 'error',
};

export function UiPreviewMenu() {
  const setBannerText = useContext(BannerContext);

  useEffect(() => {
    setBannerText('PPT에 캡처할 UI 상태를 선택해 주세요.');
  }, [setBannerText]);

  return (
    <main className='ui-preview-menu'>
      <div className='ui-preview-heading'>
        <h1>Front UI 상태 모음</h1>
        <p>각 화면은 새 탭에서 열리며, 캡처 화면에는 이 선택 메뉴가 나타나지 않습니다.</p>
      </div>
      <div className='ui-preview-grid'>
        {PREVIEW_ITEMS.map((item) => (
          <Link
            key={item.id}
            className='ui-preview-item'
            to={`/?preview=${item.id}`}
            target='_blank'
            rel='noreferrer'
          >
            <strong>{item.title}</strong>
            <span>{item.description}</span>
          </Link>
        ))}
      </div>
      <Link
        className='ui-preview-camera-link'
        to='/face-capture?mode=manual'
        target='_blank'
        rel='noreferrer'
      >
        실제 카메라 화면 열기
      </Link>
    </main>
  );
}

export function UiPreviewState({ stateId }) {
  if (stateId === 'qr-pending') {
    return <OpenIdVcRequestQR previewPhase='processing' />;
  }
  if (stateId === 'qr-error') {
    return <OpenIdVcRequestQR previewPhase='error' />;
  }
  if (stateId === 'qr-success') {
    return <OpenIdVcRequestQR previewPhase='verified' />;
  }

  const faceState = FACE_PREVIEW_STATES[stateId];
  if (faceState) {
    return <FaceCapturePage previewState={faceState} />;
  }

  return <UiPreviewMenu />;
}

UiPreviewState.propTypes = {
  stateId: PropTypes.string.isRequired,
};

export function UiPreviewShortcut() {
  return (
    <Link className='ui-preview-shortcut' to='/?preview=menu'>
      UI 상태 보기
    </Link>
  );
}
